import { render, staticRenderFns } from "./CreateChapter.vue?vue&type=template&id=7fb41528&scoped=true&"
import script from "./CreateChapter.vue?vue&type=script&lang=js&"
export * from "./CreateChapter.vue?vue&type=script&lang=js&"
import style0 from "./CreateChapter.vue?vue&type=style&index=0&id=7fb41528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb41528",
  null
  
)

export default component.exports